/* eslint-disable no-console */
<template>
    <div style="height: 50px">
        <div class="main_unit menu_center">
            <div v-if="isStoreManager" class="store_login_unit_manage_menu">{{brandStoreName}}</div>
            <div v-if="isCompanyManager" class="store_login_unit_manage_menu">企業管理者画面</div>
            <div v-if="auth == 1 || auth == 2 || auth == 5" class="company_kanri_box" id="companybrandid">
                <ul><li>
                    <router-link :to="{ name: 'manageCommpanyBrandList', params: {brandPath: brandPath} }">
                        企業一覧</router-link>
                </li></ul>
            </div>
            <div v-if="auth == 2 || auth == 3 || auth == 4  " class="company_kanri_box" id="storelistid">
                <ul><li>
                    <router-link :to="{ name: 'manageStoreList', params: {brandPath: brandPath} }">
                        店舗一覧</router-link>
                </li></ul>
            </div>
            <div v-if="auth == 5" class="company_kanri_box" id="storeCancellistid">
                <ul><li>
                    <router-link :to="{ name: 'manageStoreCancelList', params: {brandPath: brandPath} }">
                        店舗一覧</router-link>
                </li></ul>
            </div>
            <div v-if="auth == 4" class="company_kanri_box" id="stafflistid">
                <ul><li>
                <router-link :to="{ name: 'staffList', params: {brandPath: brandPath} }">
                    スタッフ一覧</router-link>
                </li></ul>
            </div>
            <div v-if="auth == 2" class="company_kanri_box" id="checksettingid">
                <ul><li>
                    <router-link :to="{ name: 'manageCheckMenuList', params: {brandPath: brandPath} }">
                        チェック内容設定</router-link></li></ul>
            </div>
            <div v-if="auth == 4" class="company_kanri_box" id="senserinfolistid">
                <ul><li><router-link :to="{ name: 'manageSenserList', params: {brandPath: brandPath}}">
                    センサー情報一覧</router-link></li></ul>
            </div>
            <div v-if="auth == 4" class="company_kanri_box" id="senserinfolistid">
              <ul><li><router-link :to="{ name: 'manageCheckImplementationMenuList', params: {brandPath: brandPath}}">
                チェック実施設定</router-link></li></ul>
            </div>
            <div v-if="auth == 2" class="company_kanri_box" id="cookingid">
                <ul><li>
                    <router-link :to="{ name: 'manageTyoriSetting', params: {brandPath: brandPath}}">
                        調理名設定</router-link>
                </li></ul>
            </div>
            <div v-if="auth == 2" class="company_kanri_box" id="sensersettingid">
                <ul><li>
                    <router-link :to="{ name: 'manageSenserSetting', params: {brandPath: brandPath,brandId:brandId,storeId:storeId}}">
                        センサー閾値登録</router-link></li></ul>
            </div>
            <div v-if="auth == 2" class="company_kanri_box" id="hygienemanagementplansettingid">
                <ul><li>
                    <router-link :to="{ name: 'manageHygieneManagementPlanSetting', params: {brandPath: brandPath}}">
                        衛生管理計画書設定</router-link></li></ul>
            </div>
            <div v-if="auth == 5" class="company_kanri_box">
                <ul><li>
                    <router-link :to="{ name: 'manageCsvExport', params: {brandPath: brandPath}}">
                        CSV出力</router-link></li></ul>
            </div>
          <div v-if="auth == 2" class="company_kanri_box" id="dashboardareasettingid">
            <ul><li>
              <router-link :to="{ name: 'dashboardAreaSetting', params: {brandPath: brandPath} }">
                ダッシュボード エリア設定</router-link></li></ul>
          </div>
          <div v-if="auth == 2" class="company_kanri_box" id="dashboardviewsettingid">
            <ul><li>
              <router-link :to="{ name: 'dashboardViewSetting', params: {brandPath: brandPath} }">
                ダッシュボード 表示設定</router-link></li></ul>
          </div>
          <div v-if="auth == 1" class="company_kanri_box" id="dashboardviewsettingid">
            <ul><li>
              <router-link :to="{ name: 'releaseSettingIndex', params: {brandPath: brandPath} }">
                お知らせ設定</router-link></li></ul>
          </div>
          <div v-if="auth == 4" class="company_kanri_box" id="sensorassignmentcookingnameid">
            <ul><li><router-link :to="{ name: 'manageSensorAssignmentCookingName', params: {brandPath: brandPath}}">
              調理名機器設定</router-link></li></ul>
          </div>
        </div>
    </div>
</template>

<script>

    export default {
    name: 'managerMenuList',
    data: function () {
        return {
            auth:'',
            brandId:'',
            storeId:''
        }
    },
    created: function(){
        this.calc();
    },
    computed:{
        brandPath: function () {
            if (this.auth == 1) {
                return process.env.VUE_APP_ADMIN_BRAND_PATH
            }
            return this.$store.getters['brand/path']
        },
        isCompanyManager: function () {
            return this.auth == 2
        },
        isStoreManager: function () {
            return this.auth == 4
        },
        brandStoreName: function () {
            let brandName = this.$store.getters['brand/name']
            let storeName = this.$store.getters['store/name']

            if (brandName == null) {
                brandName = ''
            }

            if (storeName == null) {
                storeName = ''
            }

            return brandName + '・' + storeName
        },
    },
    methods:{
        calc(){
            //権限情報を取得
            this.auth = this.$store.getters['manager/manager'].authorityKbn;
            this.brandId = this.$store.getters['brand/id'] ;
            this.storeId = this.$store.getters['store/id'] ;
        }
    }
}
</script>